import { useState } from "react";
import { HistoryList } from "@/components/history/HistoryList";
import { PeriodFilter } from "@/components/shared/PeriodFilter";
import { useHistoryData } from "@/hooks/useHistoryData";

export const History = () => {
  const [period, setPeriod] = useState("all");
  const { error, items, loading } = useHistoryData(period);

  return (
    <main className="devotional-shell min-h-screen px-4 py-8 sm:px-6 lg:px-8" data-testid="history-page">
      <div className="mx-auto max-w-5xl space-y-8">
        <section className="gentle-reveal" data-testid="history-header-section">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8C9B90]" data-testid="history-overline">Reflection archive</p>
          <h1 className="mt-3 font-serif-display text-4xl font-semibold text-[#1A3626] sm:text-5xl lg:text-6xl" data-testid="history-heading">Your remembered moments</h1>
        </section>

        <PeriodFilter activePeriod={period} onChange={setPeriod} testPrefix="history" className="sm:w-fit" />

        {error && (
          <section className="rounded-2xl border border-[#E5E1D8] bg-white p-5 text-[#A85F4B] shadow-[0_8px_30px_rgba(26,54,38,0.04)]" data-testid="history-error-message">
            {error}
          </section>
        )}

        <HistoryList items={items} loading={loading} />
      </div>
    </main>
  );
};